
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 90 612 612"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M61.2 671.482c-33.8 0-61.2-27.399-61.2-61.199v-306c0-33.8 27.4-61.2 61.2-61.2h91.558v-30.689c.056-50.719 41.158-91.82 91.876-91.876h122.4c50.719.056 91.82 41.158 91.877 91.876v30.689H550.8c33.8 0 61.2 27.4 61.2 61.2v306c0 33.8-27.4 61.199-61.2 61.199H61.2zm0-61.199h489.6v-306H61.2v306zm153.076-397.889v30.689h183.766v-30.689c-.042-16.925-13.752-30.634-30.676-30.676h-122.4c-16.93.034-30.648 13.746-30.69 30.676zm61.201 336.676v-61.354h-61.2v-61.199h61.2v-61.201h61.2v61.201h61.2v61.199h-61.2v61.366l-61.2-.012z"}})])
          )
        }
      }
    